import React from "react";
import { BellIcon, MailIcon, BellRingIcon, SmartphoneIcon, MegaphoneIcon } from "./SettingsIcons";

const NOTIFICATION_ITEMS = [
  {
    id: "email",
    label: "Email Notifications",
    desc: "Receive email updates about your account activity",
    icon: MailIcon,
    iconColor: "#eb1414",
    iconBg: "#fef2f2",
  },
  {
    id: "push",
    label: "Push Notifications",
    desc: "Get push notifications in your browser",
    icon: BellRingIcon,
    iconColor: "#3b82f6",
    iconBg: "#eff6ff",
  },
  {
    id: "sms",
    label: "SMS Alerts",
    desc: "Receive text messages for critical alerts",
    icon: SmartphoneIcon,
    iconColor: "#8b5cf6",
    iconBg: "#f5f3ff",
  },
  {
    id: "marketing",
    label: "Marketing Emails",
    desc: "Receive emails about new features and promotions",
    icon: MegaphoneIcon,
    iconColor: "#f59e0b",
    iconBg: "#fffbeb",
  },
];

const SettingsNotificationsTab = ({ notifications, setNotifications }) => {
  const toggleNotification = (id) => {
    setNotifications((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <div className="v2-settings-pg-card">
      <div className="v2-settings-pg-card__header">
        <div className="v2-settings-pg-card__icon-wrap" style={{ background: "#eff6ff" }}>
          <BellIcon size={20} color="#3b82f6" />
        </div>
        <div>
          <h3 className="v2-settings-pg-card__title">Notification Preferences</h3>
          <p className="v2-settings-pg-card__subtitle">
            Choose how you want to be notified
          </p>
        </div>
      </div>

      <div className="v2-settings-pg-card__body">
        <div className="v2-settings-pg-notif-list">
          {NOTIFICATION_ITEMS.map((item) => {
            const Icon = item.icon;
            const isOn = notifications[item.id];
            return (
              <div className="v2-settings-pg-notif-item" key={item.id}>
                <div className="v2-settings-pg-notif-item__left">
                  <div
                    className="v2-settings-pg-notif-item__icon"
                    style={{ background: item.iconBg }}
                  >
                    <Icon size={18} color={item.iconColor} />
                  </div>
                  <div className="v2-settings-pg-notif-item__text">
                    <span className="v2-settings-pg-notif-item__label">{item.label}</span>
                    <span className="v2-settings-pg-notif-item__desc">{item.desc}</span>
                  </div>
                </div>
                <button
                  className={`v2-settings-pg-toggle${isOn ? " v2-settings-pg-toggle--on" : ""}`}
                  onClick={() => toggleNotification(item.id)}
                >
                  <span className="v2-settings-pg-toggle__knob" />
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SettingsNotificationsTab;
